/* OOTB Code
We have overridden this file to trigger an event after show more ajax success to re-init lazy load and animate up */

'use strict';

const baseSearch = require('base/search/search');
const { queryFirst, updateUrlQueryParam, addClass, removeClass, queryAll, scrollTo, hasClass, renderFragment, getCookieMap, matchesBreakpoint, throttle } = require('../domUtil');
const { appendToUrl, formatMessage, getJSON } = require('../util');
const { emptySwatchTemplate } = require('../templates');
const { updatePLPTileHeight, imageAndQuickbuyHoverHandler } = require('../product/helper');
const { HIDDEN_CLASS, INVISIBLE_CLASS } = require('../constants');
const $window = $(window);
const $body = $('body');
const $container = $('.container');
const $searchResultsContainer = $('.search-results.container');
const $refinementBar = $('.refinement-bar');
const $modalBG = $('.modal-background');
const REFINEMENTS_CONTAINER_SELECTOR = '.refinements-container';
const { lp_hsc_enabled: akamaiEnabled, lp_hsc_category: plpCaching, lp_cache_hash: lpCacheHash, lp_group_hash: lpGroupHash } = getCookieMap();
const isAkamaiEnabled = (akamaiEnabled === 'true' && plpCaching && lpCacheHash && lpGroupHash);
const akamaiSettings = (queryFirst('#akamai-settings') || { dataset: {} }).dataset;
let cacheSyncTimer;
const plpHeader = queryFirst('.clp-results-header');
const mainHeader = queryFirst('.main-header');
/**
 * Function that updates action url after every ajax call
 * @param {string} actionUrl action url
 */
function updateRefinementsAjaxUrl(actionUrl) {
    const refinementsContainer = queryFirst(REFINEMENTS_CONTAINER_SELECTOR);
    if (!refinementsContainer) return;

    refinementsContainer.dataset.actionUrl = actionUrl;
}

/**
 * Append Store filter params to action Url
 * @param {HTMLElement} storeToggleEl the element which triggered the filter
 * @param {string} actionUrl action url
 * @returns {string} updated action url
 */
function appendStoreFilterQueryParams(storeToggleEl, actionUrl) {
    // If event is triggered on storeToggle Checkbox, then proceed with url updation
    if (hasClass(storeToggleEl, 'store-filter-toggle')) {
        const STORE_ID_PARAM = 'storeID';
        const { storeId } = storeToggleEl.dataset;

        // Updating relative URL query params using URL api
        const url = new URL(location.origin + actionUrl);
        const { searchParams } = url;
        if (storeToggleEl.checked) {
            searchParams.set(STORE_ID_PARAM, storeId);
        } else {
            searchParams.delete(STORE_ID_PARAM);
        }
        url.search = searchParams.toString();

        // url.pathname -> "/on/demandware.store/Sites-lillypulitzer-sfra-Site/default/Search-ShowAjax"
        // url.search -> "?cgid=dresses-1-all&prefn1=refinementCategoryDresses&prefv1=Shift%7cA-Line%2fEasy%7cStraight"
        return url.pathname + url.search;
    }
    return actionUrl;
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {string} - Selected sort.
 */
function updateSortOptions(fragment) {
    const toggleEl = queryFirst('.sort-order-menu-toggle span');
    const gridFooter = queryFirst('.grid-footer', fragment);

    if (gridFooter && toggleEl) {
        const dataSortLabel = gridFooter.dataset.sortLabel;
        toggleEl.textContent = dataSortLabel;

        const { options: sortOptions, ruleId: selectedRule } = JSON.parse(gridFooter.dataset.sortOptions);

        sortOptions.forEach(function (option) {
            const $sortOption = $('.sort-order-menu-dropdown button[data-id="' + option.id + '"], button[data-id="' + option.id + '"].sort-order-menu-option');
            $sortOption.val(option.url);
            if (option.id === selectedRule) {
                $sortOption.addClass('selected');
                $sortOption.attr('aria-selected', 'true');
                toggleEl.textContent = option.displayName;
            } else {
                $sortOption.removeClass('selected');
                $sortOption.attr('aria-selected', 'false');
            }
        });
    }
    return toggleEl ? toggleEl.textContent : '';
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom(fragment, selector) {
    const containers = queryAll(selector);
    const updates = queryFirst(selector, fragment);

    if (containers.length && updates) {
        containers.forEach(container => {
            const clone = updates.cloneNode(true);

            container.parentElement.replaceChild(clone, container);
        });
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {undefined}
 */
function handleRefinements(fragment) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = queryFirst('.' + $(this)[0].className.replace(/ /g, '.'), fragment);
        addClass(activeDiv, 'active');
        queryFirst('button.title', activeDiv).setAttribute('aria-expanded', 'true');
    });

    updateDom(fragment, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 */
function parseResults(fragment) {
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    ['.grid-header', '.header-bar', '.header.page-title', '.product-grid', '.show-more', '.filter-bar'].forEach(function (selector) {
        updateDom(fragment, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector](fragment);
    });
}

/**
 * Update search results count
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {number} Returns the total number of search results
 */
function updateCount(fragment) {
    const productCount = queryFirst('.current-product-count', fragment);
    const resultCounts = queryAll('.result-count');

    if (!productCount) {
        const noFilterResults = queryFirst('.no-filter-results', fragment);

        if (noFilterResults) {
            resultCounts.forEach(item => item.textContent = noFilterResults.dataset.noproductcount);
        }
    } else {
        resultCounts.forEach(item => item.textContent = productCount.value);
    }

    const container = queryFirst('.no-filter-results');

    if (container) {
        const numOfProducts = parseInt(resultCounts[0].innerText.replace(/\D/g, ''), 10);

        if (numOfProducts > 0) {
            addClass(container, HIDDEN_CLASS);
        } else {
            removeClass(container, HIDDEN_CLASS);
        }
    }

    return parseInt((resultCounts[0].innerText.split(' result ')[0] || '0').replace(/\D/g, ''), 10);
}

/**
 * Count the number of filters applied
 * @param {Element} element - The element containing the filter count
 * @returns {string} A display string of the filter count
 */
function refinementFilterCount(element) {
    if (!element) return '';

    let filterText = element.innerText;
    let filterAppliedCount = element.dataset.filterCount;
    const storeFilterToggle = queryFirst('.store-filter-toggle');
    const isStoreFilterApplied = storeFilterToggle && storeFilterToggle.checked;

    if (isStoreFilterApplied) {
        filterAppliedCount = parseInt(filterAppliedCount, 10) + 1;
        filterText = `${element.dataset.filterLabel} (${filterAppliedCount})`;
    }

    return filterText;
}

/**
 * Update filter count
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {undefined}
 */
function updateFilterCount(fragment) {
    const filterCount = queryFirst('.selected-filter-count', fragment);
    const productCount = queryFirst('.no-filter-results', fragment);
    const selectedFilterCount = queryFirst('.selected-filter-count');
    const showFilterSortHeader = queryFirst('.show-filter-sort-header');
    const correctFilterCount = filterCount || selectedFilterCount;
    const displayClass = 'd-md-flex';

    if (selectedFilterCount) {
        selectedFilterCount.textContent = refinementFilterCount(correctFilterCount);
    }

    // This will show/hide desktop filter and sorting fillter in desktop if product count is zero
    if (!productCount || productCount.dataset.productcount !== '0') {
        addClass(showFilterSortHeader, displayClass);
    } else {
        removeClass(showFilterSortHeader, displayClass);
    }
}

/**
 * Update show no results message
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {undefined}
 */
function showNoResultsText(fragment) {
    const noFilterResults = queryFirst('.no-filter-results', fragment);
    if (noFilterResults) {
        const numOfProducts = parseInt(noFilterResults.dataset.productcount, 10);
        if (numOfProducts > 0 && !noFilterResults.classList.contains(HIDDEN_CLASS)) {
            noFilterResults.classList.add(HIDDEN_CLASS);
        } else {
            noFilterResults.classList.remove(HIDDEN_CLASS);
        }
        const container = queryFirst('.no-filter-results');
        if (container) container.parentElement.replaceChild(noFilterResults, container);
    }
}


/**
 * Update Section based off the selector passed
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @param {String} selector - Element selector
 * @return {undefined}
 */
function updateDOMElement(fragment, selector) {
    const elementToUpdate = queryFirst(selector, fragment);
    if (elementToUpdate) {
        const container = queryFirst(selector);
        if (container) container.parentElement.replaceChild(elementToUpdate, container);
    }
}
/**
 * Update Page Title, Description and Canonical URL with color filter
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {undefined}
 */
const updatePageTitle = fragment => {
    const pageTitle = queryFirst('.seo-page-title', fragment);
    const pageDescription = queryFirst('.seo-page-description');

    if (pageTitle) document.title = pageTitle.value;

    if (pageDescription) {
        const metaTag = queryFirst('meta[name="description"]');

        if (metaTag) metaTag.setAttribute('content', pageDescription.value);
    }
};

/**
 * Update plp filters swatch images
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {undefined}
 */
function updatePatternImageSwatch(fragment) {
    const refinementPatterns = queryFirst('#refinement-print-and-solid', fragment);

    if (!refinementPatterns) return;

    const imgItems = queryAll('.refinement-image', refinementPatterns);

    imgItems.forEach(imageEl => {
        const { src, srcset } = imageEl.dataset;

        imageEl.src = src;

        if (srcset) imageEl.srcset = srcset;

        removeClass(imageEl, INVISIBLE_CLASS);
        imageEl.onload = () => addClass(imageEl, 'image-loaded');
    });

    const container = queryFirst('#refinement-print-and-solid');

    if (container) container.parentElement.replaceChild(refinementPatterns, container);
}

/**
 * Updates PLP products with out of stock text where applicable.
 * @param {Object} staleProductIds - A plain object of variation group IDs / inStock status
 */
function updateProducts(staleProductIds) {
    if (!staleProductIds || Object.keys(staleProductIds).length === 0) return;

    const productGrid = queryFirst('.product-grid');
    const currentProductIds = queryAll('.product', productGrid).map(node => node.dataset.pid).filter(Boolean);

    if (currentProductIds.length === 0) return;

    const oosProducts = Object.keys(staleProductIds).filter(productId => !staleProductIds[productId]);
    const { outOfStockMessage = '' } = productGrid.dataset;
    const oosClass = 'out-of-stock';

    oosProducts.forEach(productId => {
        const node = queryFirst(`.product[data-pid="${productId}"]`, productGrid);
        if (!node || node.classList.contains(oosClass)) return;

        const numSwatches = queryAll('.color-swatches button', node).length;
        // If there are multiple swatches, we don't know whether those are OOS too.
        if (numSwatches > 1) return;

        node.classList.add(oosClass);

        // If there's just 1 swatch, mark it as Sold Out.
        const swatches = queryFirst('.color-swatches .swatches', node);
        if (swatches) swatches.innerHTML = formatMessage(emptySwatchTemplate, outOfStockMessage);
    });
}

/**
 *
 * @param {Object} element dom element
 * @param {string} actionUrl action url
 */
function getResultsOnPriceFilter(element, actionUrl) {
    const prevActionUrl = actionUrl;
    const updatedActionUrl = appendStoreFilterQueryParams(element, actionUrl);
    const akamaiActionUrl = isAkamaiEnabled ? appendToUrl(updatedActionUrl, {
        'lp-cache-hash': lpCacheHash,
        'lp-group-hash': lpGroupHash
    }) : updatedActionUrl;
    const gridFooter = queryFirst('.grid-footer');
    const pageNumber = (gridFooter && gridFooter.dataset.pageNumber) || 0;

    $.ajax({
        url: akamaiActionUrl,
        data: {
            page: pageNumber,
            selectedUrl: akamaiActionUrl
        },
        success: function (response, status, xhr) {
            const serverTiming = xhr.getResponseHeader('server-timing') || '';
            const isCached = !!(serverTiming && serverTiming.split('desc=')[1].split(',')[0] === 'HIT');

            if (hasClass(element, 'clear-filters-btn') && ($('.no-filter-results').attr('data-productcount') === '0' || !akamaiActionUrl.includes('storeID'))) {
                $('.store-filter-toggle').prop('checked', false);
            }
            updateRefinementsAjaxUrl(prevActionUrl);

            const fragment = renderFragment(response);

            updateUrlQueryParam(fragment);
            parseResults(fragment);
            updateSortOptions(fragment);
            updatePageTitle(fragment);
            showNoResultsText(fragment);
            if (hasClass(element, 'cat-ref') || hasClass(element, 'cat-filter')) {
                updateDOMElement(fragment, '.category-breadcrumb');
                updateDOMElement(fragment, '.search-banner');
                updateDOMElement(fragment, '.cat-result-count');
            }
            // update SEO Section (it depends on selected filters)
            updateDOMElement(fragment, '.category-seo-copy');

            const productCount = updateCount(fragment);

            updateFilterCount(fragment);
            updatePatternImageSwatch(fragment);

            const container = queryFirst('.no-filter-results');
            if (container) {
                if ($('.no-filter-results').attr('data-productcount') !== '0') {
                    addClass(container, HIDDEN_CLASS);
                } else {
                    removeClass(container, HIDDEN_CLASS);
                }
            }
            $body.trigger('search:updateProducts', element); // LP custom changes end

            if (!matchesBreakpoint('lg')) {
                updatePLPTileHeight();
            }
            // Check Akamai cache
            if (isCached) {
                const cacheKey = encodeURIComponent(xhr.getResponseHeader('x-cache-key'));
                const productIds = queryAll('.product-grid .product').map(node => `${node.dataset.pid}:${!queryFirst('.swatches-empty', node)}`).filter(Boolean).join(',');
                const syncUrl = akamaiActionUrl.replace('ShowAjax', 'SyncShowAjax');

                clearTimeout(cacheSyncTimer);

                cacheSyncTimer = setTimeout(() => {
                    getJSON(syncUrl, 'POST', { productCount, cacheKey, productIds }, data => {
                        if (data.stale) {
                            // Update products with fresh stock status if we can
                            updateProducts(data.staleProductIds);

                            if (data.cacheInvalidated) {
                                // Akamai takes about 5 seconds to clear an entry
                                // Once that's complete, we should rebuild the cache with a fresh request
                                setTimeout(() => {
                                    $.ajax({
                                        url: akamaiActionUrl,
                                        data: {
                                            page: pageNumber,
                                            selectedUrl: akamaiActionUrl
                                        }
                                    });
                                }, akamaiSettings.cacheRefreshDelay);
                            }
                        }
                    });
                }, akamaiSettings.cacheSyncDelay);
            }

            $.spinner().stop();
            scrollTo(plpHeader && mainHeader ? plpHeader.offsetTop - mainHeader.offsetHeight : 0);
            // Attaching the hover event in new DOM loaded
            imageAndQuickbuyHoverHandler('.product-grid-container');
            if ($('.infinite-scroll-enabled').length > 0) {
                initialiseSearchIntersection();
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 *
 * @param {string} showMoreUrl URL used to fetch new products
 * @param {Object} e Event causing this update
 * @param {boolean} isPagination Boolean true if this is a pagination-based update; false if "Show More"
 * @param {boolean} isBackButton true if loading because of a back button click; false otherwise. Avoids pushing duplicate history entries.
 */
function loadProducts(showMoreUrl, e, isPagination, observerObj = {}, isBackButton = false) {
    $.spinner().start();
    $body.trigger('search:showMore', e);

    if (isPagination) { // scrolling to top before the new products are added to the page allows the lazy loader to be more effective
        scrollTo(plpHeader && mainHeader ? plpHeader.offsetTop - mainHeader.offsetHeight : 0);
    }

    const akamaiActionUrl = isAkamaiEnabled ? appendToUrl(showMoreUrl, {
        'lp-cache-hash': lpCacheHash,
        'lp-group-hash': lpGroupHash
    }) : showMoreUrl;

    $.ajax({
        url: akamaiActionUrl,
        data: { selectedUrl: akamaiActionUrl },
        success: (response, status, xhr) => {
            const serverTiming = xhr.getResponseHeader('server-timing') || '';
            const isCached = !!(serverTiming && serverTiming.split('desc=')[1].split(',')[0] === 'HIT');

            if (isPagination) {
                $('.product-grid').html(response);
            } else {
                $('.grid-footer').replaceWith(response);
            }

            const fragment = renderFragment(response);

            updateSortOptions(fragment);
            // LP custom changes start
            if (!isBackButton) {
                // Pagination: don't update querystring on back button click -- otherwise user gets stuck after the fist time they click back due to a new history entry being pushed
                updateUrlQueryParam(fragment);
            }

            const productCount = updateCount(fragment);

            $body.trigger('search:updateProducts');
            if (!matchesBreakpoint('lg')) {
                updatePLPTileHeight();
            }

            // Check Akamai cache
            if (isCached) {
                const cacheKey = encodeURIComponent(xhr.getResponseHeader('x-cache-key'));
                const gridFooter = queryFirst('.grid-footer', fragment);
                const pageSize = (gridFooter && parseInt(gridFooter.dataset.pageSize)) || 48;
                const productIds = queryAll('.product-grid .product').slice(-pageSize).map(node => `${node.dataset.pid}:${!queryFirst('.swatches-empty', node)}`).filter(Boolean).join(',');
                const syncUrl = akamaiActionUrl.replace('UpdateGrid', 'SyncUpdateGrid');

                clearTimeout(cacheSyncTimer);

                cacheSyncTimer = setTimeout(() => {
                    getJSON(syncUrl, 'POST', { productCount, cacheKey, productIds }, data => {
                        if (data.stale) {
                            // Update products with fresh stock status if we can
                            updateProducts(data.staleProductIds);

                            if (data.cacheInvalidated) {
                                // Once that's complete, we should rebuild the cache with a fresh request
                                setTimeout(() => {
                                    $.ajax({
                                        url: akamaiActionUrl,
                                        data: {
                                            selectedUrl: akamaiActionUrl
                                        }
                                    });
                                }, akamaiSettings.cacheRefreshDelay);
                            }
                        }
                    });
                }, akamaiSettings.cacheSyncDelay);
            }

            // LP custom changes end
            $.spinner().stop();

            // Attaching the hover event in new DOM loaded
            imageAndQuickbuyHoverHandler('.product-grid-container');
            // intersection observer changes
            if (observerObj && observerObj.target) {
                observerObj.observer.unobserve(observerObj.target);
                initialiseSearchIntersection();
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Function to apply store filter on PLP page
 * @param {HTMLElement} checkboxToggleEl Store filter toggle checkbox element
 * @param {boolean} appendStoreID Flag to append storeID to URL params
 */
function applyStoreFilter(checkboxToggleEl) {
    const refinementsContainer = queryFirst(REFINEMENTS_CONTAINER_SELECTOR);
    if (!refinementsContainer) return;

    const { actionUrl } = refinementsContainer.dataset;

    // Perform Filter
    $.spinner().start();
    getResultsOnPriceFilter(checkboxToggleEl, actionUrl);
}

/**
 * Update The filter count if storefilter is applied on load
 */
$(function () {
    const selectedFilterCountEl = queryFirst('.selected-filter-count');
    const noResultsRecommendationPage = queryFirst('.no-results-recommendations');
    const noFilterResults = queryFirst('.no-filter-results');
    const refinementPrice = queryFirst('.refinement-price');

    if (refinementPrice) {
        const minPrice = queryFirst('.price-filter-min', refinementPrice)?.value;
        const maxPrice = queryFirst('.price-filter-max', refinementPrice)?.value;

        if ((minPrice || maxPrice) && noResultsRecommendationPage) {
            addClass(noResultsRecommendationPage, HIDDEN_CLASS);
        }
    }
    if (selectedFilterCountEl) {
        const refinementFilterText = refinementFilterCount(selectedFilterCountEl);
        selectedFilterCountEl.textContent = refinementFilterText;
    }

    // On page reload or category change, if products are available
    // hide the clear filter (no results section)

    if (noFilterResults) {
        const numOfProducts = noFilterResults.dataset.productcount;
        if (numOfProducts > 0) {
            addClass(noFilterResults, HIDDEN_CLASS);
        } else {
            removeClass(noFilterResults, HIDDEN_CLASS);
        }
    }
});


$(document).ready(function () {
    if ($('.infinite-scroll-enabled').length > 0) {
        initialiseSearchIntersection();
    }
    // Attaching the hover event in new DOM loaded
    imageAndQuickbuyHoverHandler('.product-grid-container');
});

window.onload = () => {
    if (!matchesBreakpoint('lg')) {
        updatePLPTileHeight();
    }
};

/**
 * Method to initialise the  intersection observer
 *
 */
function initialiseSearchIntersection() {
    const backToTopButtonEL = queryFirst('.back-to-top-icon');
    var observerTarget = document.querySelector('.show-more.lazy-load-target');
    var options = {
        threshold: 1
    };

    /**
     * Represents a callback function which will be called when the observed target element enters the viewport
     * @param {Array} entries IntersectionObserverEntry Objects
     */
    function handleIntersect(entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                var targetURL = $('.show-more button').data('url');
                if (!targetURL) return;
                var pagination = '';
                var infiniteScrollEvent = new Event('infiniteScrollEvent');
                var observerObj = {
                    observer: observer,
                    target: observerTarget
                };
                loadProducts(targetURL, infiniteScrollEvent, !!pagination, observerObj);
                observer.unobserve(observerTarget);

                if (hasClass(backToTopButtonEL, HIDDEN_CLASS)) {
                    removeClass(backToTopButtonEL, HIDDEN_CLASS);
                }
            } else {
                return;
            }
        });
    }
    var observer = new IntersectionObserver(handleIntersect, options);
    if (observerTarget) {
        observer.observe(observerTarget);
    }
}

baseSearch.showMore = function () {
    const productGrid = queryFirst('.product-grid');
    const pagination = queryFirst('.pagination', productGrid);
    // Show more, traditional, and new pagination link event to load new products
    $container.on('click', '.show-more button, .product-grid .pagination a', function (e) {
        e.stopPropagation();
        e.preventDefault();

        const { url } = this.dataset;

        if (!url) return;

        loadProducts(url, e, !!pagination);
    });

    if (pagination) {
        const { getNestedValue } = require('../util');

        if (hasClass(pagination, 'new-pagination')) {
            $container.on('change', '.pagination-pages', e => {
                e.stopPropagation();
                loadProducts(getNestedValue(e, 'target.selectedOptions[0].dataset.url'), e, true);
            });
        }

        window.addEventListener('popstate', e => {
            const baseUrlElem = queryFirst('.ajax-base-url');
            const baseUrlWithParams = baseUrlElem && baseUrlElem.value;
            const baseUrl = baseUrlWithParams && new URL(baseUrlWithParams);
            const baseParams = baseUrl && new URLSearchParams(baseUrl.search);
            const qsParams = getNestedValue(e, 'state.path');

            if (qsParams) {
                const newParams = new URLSearchParams(qsParams.split('?')[1]);
                newParams.forEach((value, key) => {
                    baseParams.set(key, value);
                });
            }

            const finalUrl = baseUrl.origin + baseUrl.pathname + '?' + baseParams.toString();
            loadProducts(finalUrl, e, true, true);
        });
    }
};

baseSearch.applyFilter = function () {
    function onRefinement(e) {
        const target = e.currentTarget || this;
        let isSelected = hasClass(target, 'selected');
        let isCatfilter = hasClass(target, 'cat-ref');
        if (isSelected && isCatfilter) {
            return;
        }

        if (hasClass(target, 'store-filter-pill')) {
            $('.store-filter-toggle').prop('checked', false);
        }
        const { dataset } = target;

        e.preventDefault();
        e.stopPropagation();

        $.spinner().start();
        $(target).trigger('search:filter', e);
        const actionUrl = dataset.href || dataset.actionUrl;
        getResultsOnPriceFilter(target, actionUrl);
    }

    // Handle refinement value selection and reset click
    $container.on('click', '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button', onRefinement);

    $container.on('submit', '.price-filter-form', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $.spinner().start();
        $(this).trigger('search:filter', e);
        const { target } = e;
        const applyButton = queryFirst('.price-apply-button', target);
        const actionUrl = $(applyButton).attr('data-href');
        getResultsOnPriceFilter(applyButton, actionUrl);
    });

    // Prevent checkbox/toggle change is store id attribute is not present
    $container.on('click', '.store-filter-toggle', (event) => {
        if (!event.target.dataset.storeId) {
            event.preventDefault();
        }
    });

    // Toggle checkbox change event
    $container.on('change', '.store-filter-toggle', (event) => {
        applyStoreFilter(event.target);
    });

    // Selecting a store from the drawer
    $searchResultsContainer.on('filter:updateStoreId', (_e, data) => {
        // Updating new storeId on DOM
        const storeFilterToggleEl = queryFirst('.store-filter-toggle');
        const { storeId, storeName, storeCity, storeStateCode } = data;

        if (storeId) {
            // Updating toggle data attrs and state
            storeFilterToggleEl.dataset.storeId = storeId;
            storeFilterToggleEl.dataset.storeName = storeName;
            storeFilterToggleEl.disabled = false;
            storeFilterToggleEl.checked = true;

            // Updating Change store link
            const buttonLabel = `${storeName || ''} - ${storeCity || ''}, ${storeStateCode}`;
            const storeSelectorEl = queryFirst('.btn-in-store-pickup');
            if (storeSelectorEl) {
                storeSelectorEl.textContent = buttonLabel;
            }

            // Apply a store filter
            applyStoreFilter(storeFilterToggleEl);
        }
    });
    // Allow store filter to be seen / clicked now that the event handler is in place
    /** @type {HTMLInputElement} */
    const storeFilterToggle = queryFirst('.store-filter .switch');
    /** @type {HTMLInputElement} */
    const storeToggleCTA = queryFirst('.store-filter-toggle');
    if (storeFilterToggle) {
        storeToggleCTA.disabled = false;
        removeClass(storeFilterToggle, INVISIBLE_CLASS);
    }
};

baseSearch.updatePrice = function () {
    $container.on('click', '.refinement-price .values button', () => {
        addClass(queryFirst('.values button', queryFirst('.refinement-price')), 'is-not-custom');
    });
    $container.on('focus', '.refinement-price input', () => {
        removeClass(queryFirst('.price-filter', queryFirst('.refinement-price')), 'is-not-custom');
    });
    // prevent negative value
    $container.on('keydown', '.refinement-price .price-filter-min, .refinement-price .price-filter-max', e => {
        if (!((e.keyCode > 95 && e.keyCode < 106) || (e.keyCode > 47 && e.keyCode < 58) || e.keyCode == 8 || e.keyCode == 9 || e.keyCode == 38 || e.keyCode == 40 || e.keyCode == 13)) {
            return false;
        }
    });

    $container.on('keyup', '.refinement-price .price-filter-min, .refinement-price .price-filter-max', e => {
        const refinementPrice = queryFirst('.refinement-price');
        const minPrice = queryFirst('.price-filter-min', refinementPrice).value;
        const maxPrice = queryFirst('.price-filter-max', refinementPrice).value;
        const applyButton = queryFirst('.price-apply-button', refinementPrice);
        removeClass(queryAll('.values button', refinementPrice), 'selected');
        if (minPrice) {
            queryFirst('.price-filter-max', refinementPrice).min = parseInt(minPrice) + 1; // setting min value for max input
        }

        // Enable or disable apply button based min and max filter value
        if (minPrice && maxPrice && parseInt(minPrice) < parseInt(maxPrice)) {
            applyButton.disabled = false;
        } else {
            applyButton.disabled = true;
        }
    });

    $container.on('change', '.refinement-price .price-filter-min, .refinement-price .price-filter-max', e => {
        const refinementPrice = queryFirst('.refinement-price');
        const minPrice = queryFirst('.price-filter-min', refinementPrice).value;
        const maxPrice = queryFirst('.price-filter-max', refinementPrice).value;
        const applyButton = queryFirst('.price-apply-button', refinementPrice);
        const uri = applyButton.dataset.href;

        let newUrl = '';

        if (minPrice && maxPrice) {
            const updateQueryStringParameter = (key, value) => {
                const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
                const separator = uri.indexOf('?') !== -1 ? '&' : '?';
                if (uri.match(re)) {
                    newUrl = newUrl ? newUrl.replace(re, '$1' + key + '=' + value + '$2') : uri.replace(re, '$1' + key + '=' + value + '$2');
                } else {
                    newUrl = newUrl ? newUrl + separator + key + '=' + value : uri + separator + key + '=' + value;
                }
            };

            updateQueryStringParameter('pmin', parseInt(minPrice, 10));
            updateQueryStringParameter('pmax', parseInt(maxPrice, 10));
            applyButton.dataset.href = newUrl;
        }
    });
};

/**
 * Show the filter refinements UI
 */
function showRefinements() {
    $refinementBar.show();
    $modalBG.show();
    $refinementBar.siblings().attr('aria-hidden', true);
    $refinementBar.closest('.row').siblings().attr('aria-hidden', true);
    $refinementBar.closest('.tab-pane.active').siblings().attr('aria-hidden', true);
    $refinementBar.closest('.container.search-results').siblings().attr('aria-hidden', true);
    $refinementBar.find('.close').trigger('focus');
}

/**
 * Hide the filter refinements UI
 */
function hideRefinements() {
    $refinementBar.hide();
    $modalBG.hide();
    $refinementBar.siblings().attr('aria-hidden', false);
    $refinementBar.closest('.row').siblings().attr('aria-hidden', false);
    $refinementBar.closest('.tab-pane.active').siblings().attr('aria-hidden', false);
    $refinementBar.closest('.container.search-results').siblings().attr('aria-hidden', false);
}

baseSearch.filter = function () {
    // Display refinements bar when Menu icon clicked
    $container.on('click', 'button.filter-results', function () {
        showRefinements();

        // LP custom changes start
        $body.addClass('modal-open');
        // LP custom changes end
    });
};

baseSearch.closeRefinements = function () {
    // Refinements close button
    $container.on('click', '.refinement-bar button.close, .modal-background', function () {
        hideRefinements();

        const filterResults = queryFirst('.filter-results');

        if (filterResults) filterResults.focus();

        // LP custom changes start
        $body.removeClass('modal-open');
        // LP custom changes end
    });
};

baseSearch.resize = function () {
    const { documentElement } = document;
    const { clientWidth } = documentElement;
    // Close refinement bar and hide modal background if user resizes browser
    $window.on('resize', throttle(() => {
        // Check if the window width has actually changed and it's not just iOS triggering a resize event on scroll
        if (documentElement.clientWidth !== clientWidth) {
            if (window.matchMedia('(min-width: 768px)').matches) {
                hideRefinements();

                // LP custom changes start
                $body.removeClass('modal-open');
                // LP custom changes end
            }
            if (!matchesBreakpoint('lg')) {
                setTimeout(() => {
                    updatePLPTileHeight('filter');
                }, 200);
            } else {
                let cards = $('.tile-img-link');
                cards.height('100%');
            }
        }
    }, 100));
};

baseSearch.sortHandler = function () {
    $body.on('search:sortOptions', function (e, data) {
        const { response } = data;
        const fragment = renderFragment(response);

        updateUrlQueryParam(fragment);
        parseResults(fragment);
        const sortText = updateSortOptions(fragment);
        showNoResultsText(fragment);
        updateCount(fragment);
        updateFilterCount(fragment);
        updatePatternImageSwatch(fragment);
        // Attaching the hover event in new DOM loaded
        imageAndQuickbuyHoverHandler('.product-grid-container');
        if ($('.infinite-scroll-enabled').length > 0) {
            initialiseSearchIntersection();
        }
        $body.trigger('search:updateProducts', { sortText: sortText.toLowerCase() });
    });
};

/**
 * Sometimes when user back to PLP with infinite scroll,
 * safari for some reason lost scroll position.
 * This is dirty hack to fix for this. We store last interacted tile
 * in url and then force browser to scroll to it.
 */
baseSearch.focusTileOnBackButton = function () {
    const productGridContainer = queryFirst('.product-grid-container');
    let activeTileId = '';

    function hasParentTile(el) {
        let tile = null;

        while ((el = el.parentNode) && el !== document) {
            if (el.id && el.id.startsWith('product-tile-')) {
                tile = el;
                break;
            }
        }

        return tile;
    }

    function tileInteractionHandler(event) {
        const tile = hasParentTile(event.target);
        if (tile !== null) {
            activeTileId = tile.getAttribute('id');
        }
    }

    function unloadHandler() {
        if (activeTileId === '') { return; }

        const url = new URL(window.location.href);
        url.hash = activeTileId;
        window.history.replaceState(window.location.href, '', url);
    }

    if (productGridContainer) {
        productGridContainer.addEventListener('click', tileInteractionHandler);
    }

    window.addEventListener('pagehide', unloadHandler);

    function scrollToProductTile() {
        const url = new URL(window.location.href);
        if (!url.hash.startsWith('#product-tile')) return;

        const target = queryFirst(url.hash);
        if (!target) return;

        target.focus();
        target.scrollIntoView();
    }

    scrollToProductTile();
}

module.exports = baseSearch;
